import { createI18n } from 'vue-i18n';


export const i18n = createI18n({
  locale: (
    localStorage.getItem("user_language") || window.navigator.language
  ).split("-")[0],
  fallbackLocale: "es"
});
